import React, { Component } from "react";
import { Col, Label, Dropdown, DropdownToggle } from "reactstrap";
import Select from "react-select";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { enableClass, disableClass, enableTeacher, selectSchoolOption, disableTeacher, selectTeacher, selectClasses, selectStudentOption } from './../../../redux/modules/users'
import isLicensedUser from '../../../helpers/users/licenses/isLicensedUser'
import getSchoolYear from '../../../helpers/getSchoolYear' 
import determineSchoolYear from '../../../helpers/determineSchoolYear' 

class SearchDropdown extends Component {
  state = {
    dropdownOpen: false,

    filter: "",
    selectedOption: null,
    newfilteredGroupData : null,
    isDuplicate : false,
    users: null,
    loadingLicenses: false,
    licensedUsers: [],
    licenseEndDate: null
  };
  componentWillReceiveProps(nextProps){ 
    this.handleDuplicateCheck(nextProps)
  }

  handleDuplicateCheck(nextProps) {
    let { filteredGroupData, selection} = nextProps;
    const { year } = this.props;

    filteredGroupData = filteredGroupData.filter( user => 
    ((this.state.licensedUsers).includes(user.id) && 
    determineSchoolYear(this.state.licenseEndDate).split('sy')[1] >= 
    getSchoolYear().year.split('sy')[1] && getSchoolYear().year == year) 
    || determineSchoolYear(user.created) === year ) 

    if (selection.Teacher) {
      var arr = filteredGroupData
      const sorter = (a, b) => {
        if (b.name < a.name) return 1
        if (b.name > a.name) return -1
        return 0
      }
      var sorted_arr = arr.slice().sort(sorter);
      var results = []
      for (var i = 0; i < sorted_arr.length - 1; i++) {
          if (sorted_arr[i + 1].name == sorted_arr[i].name) {
              results.push(sorted_arr[i])
          }
      }
      if (results.length > 0) {
        this.setState({isDuplicate:true})
      } else {
        this.setState({isDuplicate:false})
      }
      this.setState({newfilteredGroupData : filteredGroupData}) 
    }
    else {
      if (filteredGroupData !== this.state.newfilteredGroupData){
        this.setState({newfilteredGroupData : filteredGroupData})
      } 
  
    }
  }
  
  componentDidMount(){
    
    isLicensedUser(this.props.filteredGroupData, this.setState.bind(this))
    // let {filteredGroupData} = this.props; 
    this.handleDuplicateCheck(this.props)
    // this.setState({newfilteredGroupData : filteredGroupData}) 
  }

  componentWillUnmount() {
    let history = this.props.history.location.pathname
    if (!(history.includes('/assessment'))) {
      this.props.disableClass();
      this.props.disableTeacher();
      this.props.selectSchoolOption(null);
      this.props.selectStudentOption(null);
      this.props.selectTeacher(null);
      this.props.selectClasses(null);
    }
  }

  toggle = () => this.setState({ dropdownOpen: !this.state.dropdownOpen });
  changeFilterData = selectedOption => {
    if (!selectedOption.itemNumber) {
      this.props.selectGroupUA(selectedOption.key);
    } else {
      this.props.selectGroupUA(selectedOption.key, selectedOption.itemNumber);
    }
    if (selectedOption.groupType === "Teacher") {
      if (selectedOption.label === "---") {
        this.props.disableClass();
        this.props.selectClasses(null);
        this.props.selectTeacher(selectedOption);
      } else {
        this.props.enableClass();
        this.props.selectTeacher(selectedOption);
        this.props.selectClasses(null);
      }
    }
    if (selectedOption.groupType === "Class") {
      if (selectedOption.label === "---") {
        this.props.selectStudentOption(null);
        this.props.selectClasses(selectedOption);
      } else {
        this.props.selectClasses(selectedOption);
        this.props.selectStudentOption(null);
      }
    }

    if (selectedOption.groupType === "School") {
      if (selectedOption.label === "---") {
        this.props.disableClass();
        this.props.disableTeacher();
        this.props.selectSchoolOption(null);
      } else {
        this.props.selectSchoolOption(selectedOption);
        this.props.enableTeacher();
        this.props.disableClass();
      }
      this.props.selectClasses(null);
      this.props.selectTeacher(null);
    }
    if (selectedOption.label === "---") {
      selectedOption.label = "";
    }
    this.setState({ filter: "", selectedOption: selectedOption });
  };
  changeFilter = ({ target }) => this.setState({ filter: target.value });

  render() {
    const { selectedOption , newfilteredGroupData} = this.state;
    const {
      groupType,
      itemNumber,
      selection,
      filteredGroupData,
      selectedClass,
      selectedTeacher,
      selectedSchool,
      role
    } = this.props;
   const { dropdownOpen, filter, isDuplicate } = this.state;
    const { toggle, changeFilter } = this;

    const groupTypesByRole = {
      "Super Administrator": ["School District", "School", "Teacher", "Class"],
      "District Admin": ["School District", "School", "Teacher", "Class"],
      "School Admin": ["School", "Teacher", "Class"],
      Teacher: ["Teacher", "Class"]
    };

    const groupTypes = groupTypesByRole[role];

    const groupKeys = {
      "School District": "districts",
      School: "schools",
      Teacher: "educators",
      Class: "classes",
      Student: "students"
    };
    const backtrack = {
      School: "School District",
      Teacher: "School",
      Class: "Teacher",
      Student: "Class"
    };

    let backtrackId = "";
    if (groupType !== groupTypes[0]) {
      backtrackId = selection[backtrack[groupType]];
    }

    let options = [];
    if (backtrackId || groupType !== groupTypes[0]) {
      // options.push(<option value={backtrackId} key={`${groupType}OptionNull`}></option>)

      options.push({
        value: backtrackId,
        label: "---",
        key: backtrackId,
        itemNumber: itemNumber,
        groupType: groupType
      });
    }

    newfilteredGroupData && newfilteredGroupData.forEach(group => {
      if (
        !filter ||
        (group.name &&
          group.name.toLowerCase().indexOf(filter.toLowerCase()) > -1) ||
        (group.fullName &&
          group.fullName.toLowerCase().indexOf(filter.toLowerCase()) > -1)
      ) {
        options.push({
          value: groupType === "Teacher" ? group.fullName : group.id,
          label: groupType === "Teacher" ? group.fullName : isDuplicate ?  group.name + " - " + group.period : group.name,
          key: group.id,
          itemNumber: itemNumber,
          groupType: groupType
        });
      }
    });
    const selectWidthControl = {
      minWidth: "190px"
    };
    let selectedValue = "";
    if (groupType === "Class") {
      selectedValue = this.props.classes_selected_value;
      options.forEach(option => {
        if (option.key === selectedClass) {
          selectedValue = option;
          //this.props.enableClass();
        }
      });
    } else if (groupType === "Teacher") {
      selectedValue = this.props.teacher_selected_value;
      options.forEach(option => {
        if (option.key === selectedTeacher) {
          selectedValue = option;
          // this.props.enableTeacher();
        }
      });

    } else if (groupType === "Students") {
      selectedValue = this.props.student_selected_value;
    } else if (groupType === "School") {
      selectedValue = this.props.school_selected_value;
      options.forEach(option => {
        if (option.key === selectedSchool) {
          selectedValue = option;
        }
      });

    }
    else {
      selectedValue = selectedOption;
    }
    return (
      <Col xl="2" lg="2" md="6" sm="12" style={selectWidthControl}>
        <Dropdown isOpen={dropdownOpen} toggle={toggle}>
          <DropdownToggle
            tag="span"
            onClick={toggle}
            data-toggle="dropdown"
            aria-expanded={dropdownOpen}
          >
            <Label>{`${groupType}:`}</Label>

            <Select
              placeholder={
                (role === "Teacher" && groupType == "Teacher") ||
                  (role === "School Admin" &&
                    groupType == "School" &&
                    options.length > 0)
                  ? options[0].value
                  : ""
              }
              isDisabled={
                (role === "Teacher" && groupType == "Teacher" && (selectedValue == null || selectedValue == "")) ||
                  (role === "School Admin" && groupType == "School" && (selectedValue == null || selectedValue == "")) ||
                  (role !== "Teacher" &&
                    groupType == "Class" &&
                    !this.props.is_class_enable && (selectedValue == null || selectedValue == "") && (selectedTeacher===null || selectedTeacher=='')) ||
                  (role === "District Admin" &&
                    groupType == "Teacher" &&
                    !this.props.is_teacher_enable) && (selectedValue == null || selectedValue == "")
                  ? true
                  : false
              }
              options={options}
              onChange={this.changeFilterData}
              value={selectedValue}
            />
          </DropdownToggle>
        </Dropdown>
      </Col>
    );
  }
}

const mapStatetoProps = state => {
  return {
    is_class_enable: state.users.is_class_enable,
    is_teacher_enable: state.users.is_teacher_enable,
    classes_selected_value: state.users.classes_selected_value,
    school_selected_value: state.users.school_selected_value,
    teacher_selected_value: state.users.teacher_selected_value,
    student_selected_value: state.users.student_selected_value
  };
};

const mapDispatchToProps = dispatch => {
  return {
    enableClass: () => {
      { dispatch(enableClass()) }
    },
    enableTeacher: () => {
      { dispatch(enableTeacher()) }
    },
    disableClass: () => {
      { dispatch(disableClass()) }
    },

    disableTeacher: () => {
      { dispatch(disableTeacher()) }
    },
    selectTeacher: (selectedValue) => {
      dispatch(selectTeacher(selectedValue))
    }
    ,
    selectClasses: (selectedValue) => {
      dispatch(selectClasses(selectedValue))
    }
    ,
    selectStudentOption: (selectedValue) => {
      dispatch(selectStudentOption(selectedValue))
    }
    ,
    selectSchoolOption: (selectedValue) => {
      dispatch(selectSchoolOption(selectedValue))
    }
  }
}

export default connect(
  mapStatetoProps,
  mapDispatchToProps
)(withRouter(SearchDropdown))



// WEBPACK FOOTER //
// ./src/components/Assessment/AssessSelectorBar/SearchDropdown.js